import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  getSuggestedFilterOptionDOMId,
  useSearchBarState,
} from 'Components/AdvisorApp/Header/ClientSearchBar/BetaSearchBar/SearchBarContext';
import SuggestedFilter
  from 'Components/AdvisorApp/Header/ClientSearchBar/BetaSearchBar/ResultsPopper/SuggestedFilters/SuggestedFilter';

const styles = (theme) => ({
  root: {},
  title: {
    pointerEvents: 'none',
    userSelect: 'none',
    padding: theme.spacing(1),
  },
  suggestedFilter: {},
});

const SuggestedFilters = ({
  className,
  classes,
  selectedDOMId,
}) => {
  const {
    suggestedFilterOptions,
    searchTerm,
    searchType,
  } = useSearchBarState();

  if (searchType !== null && searchTerm.length > 0) {
    return null;
  }

  const options = suggestedFilterOptions;

  if (options.length === 0) {
    return null;
  }

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Typography
        className={classes.title}
        color={'primary'}
        variant={'h4'}
        weight={'medium'}
        test={'global-search-suggested-filters-title'}
      >
        {'Suggested Filters'}
      </Typography>
      {options.map((option) => {
        const optionId = option.attr('id');
        return (
          <SuggestedFilter
            key={optionId}
            className={classes.suggestedFilter}
            id={optionId}
            isSelected={selectedDOMId === getSuggestedFilterOptionDOMId(optionId)}
            prompt={option.attr('prompt')}
          />
        );
      })}
    </Box>
  );
};

SuggestedFilters.defaultProps = {
  className: '',
  selectedDOMId: null,
};

SuggestedFilters.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  selectedDOMId: PropTypes.string,
};

export default withStyles(styles)(SuggestedFilters);
